import PageTitle from "../page-header/PageHeader";
//import GetAllProd from "./getAllProd";
//import GetAllRunningSize from "./getAllRunningSize";

import { Navigate } from "react-router-dom";
//import AddProd from "./addProd";
import AddSingleRate from "./addSingleRate";


const RateCalculator = (props) => {
  const isLogged = Boolean(localStorage.getItem("isLogged"));

  if (!isLogged) {
    return <Navigate to={"/auth/login"} replace={true} />;
  }

  return (
    <>
      <PageTitle title="Back" />

      {/* <AddProd /> */}

      <AddSingleRate/>
      {/* <GetAllProd /> */}
      {/* <GetAllRunningSize /> */}
    </>
  );
};

export default RateCalculator;
